import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { runIfFn } from "./chunk-EBS47JIL.mjs";

// src/components/drawer.ts
import { drawerAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $bg = cssVar("drawer-bg");
var $bs = cssVar("drawer-box-shadow");
function getSize(value) {
  if (value === "full") {
    return definePartsStyle({
      dialog: {
        maxW: "100vw",
        h: "100vh"
      }
    });
  }
  return definePartsStyle({
    dialog: {
      maxW: value
    }
  });
}
var baseStyleOverlay = defineStyle({
  bg: "blackAlpha.600",
  zIndex: "overlay"
});
var baseStyleDialogContainer = defineStyle({
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
});
var baseStyleDialog = defineStyle(function (props) {
  var _dark, _objectSpread2;
  var isFullHeight = props.isFullHeight;
  return _objectSpread(_objectSpread({}, isFullHeight && {
    height: "100vh"
  }), {}, (_objectSpread2 = {
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit"
  }, _defineProperty(_objectSpread2, $bg.variable, "colors.white"), _defineProperty(_objectSpread2, $bs.variable, "shadows.lg"), _defineProperty(_objectSpread2, "_dark", (_dark = {}, _defineProperty(_dark, $bg.variable, "colors.gray.700"), _defineProperty(_dark, $bs.variable, "shadows.dark-lg"), _dark)), _defineProperty(_objectSpread2, "bg", $bg.reference), _defineProperty(_objectSpread2, "boxShadow", $bs.reference), _objectSpread2));
});
var baseStyleHeader = defineStyle({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton = defineStyle({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody = defineStyle({
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
});
var baseStyleFooter = defineStyle({
  px: "6",
  py: "4"
});
var baseStyle = definePartsStyle(function (props) {
  return {
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer,
    dialog: runIfFn(baseStyleDialog, props),
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody,
    footer: baseStyleFooter
  };
});
var sizes = {
  xs: getSize("xs"),
  sm: getSize("md"),
  md: getSize("lg"),
  lg: getSize("2xl"),
  xl: getSize("4xl"),
  full: getSize("full")
};
var drawerTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "xs"
  }
});
export { drawerTheme };